import React from 'react';
import { useIntl } from 'react-intl';
import { StyledNavButton, StyledNavIconWrapper } from '../../styled/StyledNavButton';
import { locales } from '../../helpers/site';
import FlagIcon from '../FlagIcon';

interface ILocaleButtonDesktopProps {
  toggle: () => void;
}

export const LocaleButtonDesktop = ({ toggle }: ILocaleButtonDesktopProps) => {
  const { locale } = useIntl();

  const toggleLocaleModal = () => {
    toggle();
  };

  return (
    <StyledNavButton onClick={toggleLocaleModal} buttonType="tertiary" $spaceBetween>
      <StyledNavIconWrapper className="nav-icon-wrapper" $withRounding>
        <FlagIcon locale={locales[locale].xcode} alt={`Selected Language: ${locales[locale].name}`} />
      </StyledNavIconWrapper>
      {locales[locale].nameLocal}
    </StyledNavButton>
  );
};
